import { render, staticRenderFns } from "./SvgView.vue?vue&type=template&id=27a46b34&"
import script from "./SvgView.vue?vue&type=script&lang=js&"
export * from "./SvgView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('27a46b34', component.options)
    } else {
      api.reload('27a46b34', component.options)
    }
    module.hot.accept("./SvgView.vue?vue&type=template&id=27a46b34&", function () {
      api.rerender('27a46b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/SvgView.vue"
export default component.exports